import { type CoreInsurancePayload, type CoreInsurance } from '@flecto/types'

import { api } from '../../../services/api'

export async function updateInsurance(
  insurance: Pick<CoreInsurance, 'notes' | 'internal_id'>
): Promise<CoreInsurance> {
  const body: Pick<CoreInsurancePayload, 'notes'> = {
    notes: insurance.notes,
  }

  const response = await api.put(
    `/api/saas/me/insurances/${insurance.internal_id}`,
    body
  )

  return response.data.insurance
}
